export default __webpack_public_path__ + "locales/sr-Cyrl-RS/JavascriptSdk.json?hash=5496adb606360c37b4cf488628a03b21";